
document.addEventListener("DOMContentLoaded", function () {
    const rating_grid_items = document.querySelectorAll(".rating_grid-item");
    const videoSection = document.querySelector(".footer-video-section");
    const iframe = videoSection ? videoSection.querySelector("iframe") : null;
  
    if (!videoSection || !iframe) {
      return;
    }
  
    rating_grid_items.forEach((rating_grid_item) => {
        rating_grid_item.addEventListener("click", function () {
        const playWrapper = rating_grid_item.querySelector(".rating_grid-button");
        if (!playWrapper) {
          console.error("No video wrapper found in this item");
          return;
        }
  
        const video_id = playWrapper.getAttribute("data-video_id");
        if (!video_id) {
          console.error("No video ID found!");
          return;
        }
  
        const embed_url = `https://www.youtube.com/embed/${video_id}?feature=oembed&amp;autoplay=1`;
        iframe.setAttribute("src", embed_url);
  
        // Show video section
        videoSection.style.display = "block";
        document.querySelector("html").classList.add("custom-video-is-playing");
      });
    });
  
    // Click outside iframe to close video
    videoSection.addEventListener("click", function (event) {
      if (!event.target.closest("iframe")) {
        document.querySelector("html").classList.remove("custom-video-is-playing");
        videoSection.style.display = "none";
        iframe.setAttribute("src", ""); // Reset the iframe source to stop video
      }
    });
  });